// extracted by mini-css-extract-plugin
export var footer = "_qv-0";
export var inherit = "_qv-1";
export var input = "_qv-2";
export var modalContent = "_qv-3";
export var quillEditor = "_qv-4";
export var subtitle = "_qv-5";